import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, vShow as _vShow, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 2,
  class: "as-tab-content"
}

import { ref, computed, watch } from "vue";
import type { IStatistics, IMatch } from "~src/interfaces/basketball";
import StatisticsItem from "~src/components/statistics/basketball/StatisticsItem.vue";
import {
  getProcessedStats,
  initializeData,
} from "~src/helpers/basketball/index";
import { usecommonStore } from "~src/stores/CommonStore";

const __default__ = {};

interface IProps {
  statistics: IStatistics[];
  match: IMatch;
  isHomePage: boolean;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'StatisticsList',
  props: {
    statistics: {},
    match: {},
    isHomePage: { type: Boolean, default: false }
  },
  setup(__props: any) {

const commonStore = usecommonStore();

const props = __props;

const siteName = computed(() => commonStore.getSiteName);
const dataDefault = initializeData();
const activeTab = ref(0);

const statisticAll = computed<any>(() => {
  const data = props.statistics[0];
  return data;
});

const isShowTab = computed(() => {
  if (!statisticAll.value || statisticAll.value.type === 10) {
    return false;
  }

  const stats = getProcessedStats(props.match, statisticAll.value, false);

  return stats.length > 0;
});

const getTabLabel = (type: number | string): string | null | undefined => {
  switch (type) {
    case 0:
      return "Tất cả";
    case 2:
      return "Hiệp 1";
    case 4:
      return "Hiệp 2";
    case 6:
      return "Hiệp 3";
    case 8:
      return "Hiệp 4";
    case 9:
      return "OT";
    default:
      return undefined;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      { 'as-statistic-home': _ctx.isHomePage },
      `as-parent-statics as-parent-statics-${siteName.value}`,
    ])
  }, [
    (isShowTab.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["as-nav-tabs-btn as-nav-tabs-btn__border", `as-nav-tabs-btn-${siteName.value}`])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statistics, (tab) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["as-nav-item", { active: activeTab.value === tab.type }]),
              key: tab.id,
              onClick: ($event: any) => (activeTab.value = tab.type)
            }, [
              _cache[0] || (_cache[0] = _createElementVNode("span", { class: "as-extra-item" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(getTabLabel(tab.type)), 1)
            ], 10, _hoisted_1))
          }), 128))
        ], 2))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(StatisticsItem, {
            statistics: _unref(dataDefault),
            match: _ctx.match,
            isHomePage: _ctx.isHomePage,
            isDefault: true
          }, null, 8, ["statistics", "match", "isHomePage"])
        ])),
    (isShowTab.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statistics, (statistic) => {
            return _withDirectives((_openBlock(), _createBlock(StatisticsItem, {
              key: statistic?.id,
              statistics: statistic,
              match: _ctx.match,
              isHomePage: _ctx.isHomePage
            }, null, 8, ["statistics", "match", "isHomePage"])), [
              [_vShow, activeTab.value === statistic.type]
            ])
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})